export const applicationTeamMemberMapSF = {
  direction: 'in',
  Id: 'id',
  UserId: 'userId',
  TeamMemberRole: 'teamMemberRole',
  OpportunityAccessLevel: 'access'
}

export interface ApplicationTeamMember {
  id: string
  teamMemberRole: 'Manager' | 'Contributor' | 'Operator' | 'Selection Committee Member'
  userId: string
  access: string
}
